<template>
    <section class="call-waiting">
    <div class="waiting-content">
      <span class="img-heading" v-if="findAnotherCallBtnProp">
        <img :src="require('../../assets/images/its-a-match.png')" alt="">
      </span>
      <div class="caller-profiles">
        <span class="profile-content">
        <span class="caller-profile-img"><img :src="($store.state.userImg.img_url === 'avatar1' || !$store.state.userImg.img_url) ?  require('../../assets/images/mask.png') : $store.state.userImg.img_url" alt=""/> </span>
        <span class="caller-profile-name">{{$store.state.userImg.nick_name}} </span>
        </span>
           
        <span class="profile-content">
        <span class="caller-profile-img"><img :src="(callerImg === 'avatar1' || !callerImg) ? require('../../assets/images/mask.png') : callerImg" alt=""></span>
        <span class="caller-profile-name">{{message}} </span>
        </span>
      </div>
      <!-- <div class="msg"> 
        <span v-if="(!internetDisconnect && !findAnotherCallBtnProp)">{{$t('callWaiting')}}</span>
        <span v-if="internetDisconnect">{{$t('Re-connecting')}}</span>
        <p>
          {{$t('wanttotalk')}}
          {{$t('clickButton',{userPositiontxt:userPosition})}}
        </p>
        <button @click="handleCalltoCaller" :class="(findAnotherCallBtn || findAnotherCallBtnProp) ? 'disable' : ''">{{$t('FindAnotherFriend')}}</button>
      </div> -->
    </div>
    <div class="calling-tools">
      <div class="inner">
        <span class="mute">
          {{$t('Mute')}}
        </span>
        <span class="call-btn" @click="handleExit">
          <img :src="require('../../assets/images/call-btn.svg')" alt="">
        </span>
        <span class="speaker">
          {{$t('Speaker')}}
        </span>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "CallToCaller",
  props:{
    callerImg: String,
    message: String,
    matchDetails: Object,
    userPosition: Number,
    internetDisconnect: Boolean,
    findAnotherCallBtnProp: Boolean
  },
  methods:{
      handleCalltoCaller(){
        this.$emit('handleCalltoCaller')
        this.findAnotherCallBtn = true
      },
      handleExit(){
        this.$emit('handleExit')
      }
  },
  data(){
      return{
          checked: false,
          findAnotherCallBtn: false
      }
  },
  mounted(){
    console.log('==matchDetails==',this.matchDetails)
  }
}
</script>